<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Harvest Activities
      </h5>
    </b-form-row>
    <template v-if="harvestExists && harvestDetails">
      <DetailRow
        label="Total size of the area to be harvested"
        :value="`${$options.filters.numberString(harvestDetails.totalHarvestArea)} acres`"
      />
      <ul class="summary-list mb-0">
        <li>
          The land that you intend to harvest
          <strong>IS {{harvestDetails.taxLaw | emptyOrNot}}</strong>taxed under the Maine Tree
          Growth Tax Law.
        </li>
        <li>
          The land use <strong>WILL {{harvestDetails.landUseChange | emptyOrNot}}</strong>be
          converted to something other than forest within 2 years.
        </li>
      </ul>
      <template v-if="harvestDetails.landUseChange">
        <DetailRow
          label="Post Operation Land Use"
          :value="getLandUseCategory(harvestDetails.landUseChangeCategoryId)"
        />
        <DetailRow
          label="Land Use Acreage"
          :value="`${$options.filters.numberString(harvestDetails.landUseChangeArea)} acres`"
        />
      </template>
      <ul class="summary-list">
        <li>
          Harvest <strong>WILL {{harvestDetails.clearcut20 | emptyOrNot}}</strong>create
          clearcuts larger than 20 acres.
        </li>
        <li>
          Harvest <strong>WILL {{harvestDetails.clearcut75 | emptyOrNot}}</strong>create
          clearcuts larger than 75 acres.
        </li>
        <li>
          Harvesting <strong>WILL {{harvestDetails.waterFeatureTypeId === 3 | emptyOrNot}}</strong>be
          <strong>within a 250-foot wide regulated area</strong> adjacent to a Great Pond, river or
          regulated wetland, and/or <strong>within a 75-foot wide regulated area</strong> adjacent
          to a stream (including unmapped streams)
        </li>
        <li>
          You <strong>WILL {{harvestDetails.woodToStream | emptyOrNot}}</strong>be adding wood to a
          stream that is consistent with the
          <a
            :href="links.chapter25Rules"
            target="_blank"
            rel="noopener noreferrer"
          >MFS Chapter 25 Rule</a>.
        </li>
      </ul>
      <template v-if="harvestDetails.waterFeatureTypeId === 3 && harvestDetails.sws250ComplianceTypeId">
        <div class="font-weight-bold mb-2">
          One or more proposed Harvest Activities will be within a shoreland area with the 250-foot
          Statewide Standard.
        </div>
        <div class="text-primary mr-3">
          The following option will be used to comply with Maine Forest Service
          Chapter 21,
          <a
            :href="links.chapter21Section7"
            target="_blank"
            rel="noopener noreferrer"
          >
          Section 7</a>
          rules for Shade and Tree Retention 250-foot Standard:
          <span class="text-default">
            {{getSWSComplianceType(harvestDetails.sws250ComplianceTypeId)}}
          </span>
        </div>
      </template>
      <template v-if="harvestDetails.waterFeatureTypeId === 3 && harvestDetails.sws75ComplianceTypeId">
        <div class="font-weight-bold mb-2">
          One or more proposed Harvest Activities will be within a shoreland area with the 75-foot
          Statewide Standard.
        </div>
        <div class="text-primary mr-3">
          The following option will be used to comply with Maine Forest Service
          Chapter 21,
          <a
            :href="links.chapter21Section8"
            target="_blank"
            rel="noopener noreferrer"
          >
          Section 8</a>
          rules for Shade and Tree Retention 75-foot Standard:
          <span class="text-default">
            {{getSWSComplianceType(harvestDetails.sws75ComplianceTypeId)}}
          </span>
        </div>
      </template>
    </template>
    <p v-else>
      No Harvest Activity is proposed.
    </p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';
import DetailRow from '@/components/DetailRow.vue';

export default {
  name: 'HarvestDetails',
  components: {
    DetailRow,
  },
  created() {
    this.$store.dispatch(`${LookupModules.SWS_COMPLIANCE_TYPES.namespace}/fetchOptions`);
    this.$store.dispatch(`${LookupModules.LAND_USE_CATEGORIES.namespace}/fetchOptions`);
  },
  computed: {
    ...mapState('ActivityDetails', {
      harvestDetails: state => state.activityDetails.harvestDetails,
      requirements: state => state.requirements,
    }),
    ...mapState('Configuration', {
      links: state => state.links,
    }),
    ...mapState(LookupModules.SWS_COMPLIANCE_TYPES.namespace, {
      swsComplianceTypes: state => state.options,
      swsComplianceTypesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.LAND_USE_CATEGORIES.namespace, {
      landUseCategories: state => state.options,
      landUseCategoriesLoading: state => state.loading,
    }),
    ...mapGetters('Activity', ['harvestExists']),
    ...mapGetters(LookupModules.LAND_USE_CATEGORIES.namespace, {
      getLandUseCategory: 'getName',
    }),
    ...mapGetters(LookupModules.SWS_COMPLIANCE_TYPES.namespace, {
      getSWSComplianceType: 'getName',
    }),
  },
};
</script>
